export const colours = {
  seafoam: '#34a5ac', // Primary colour
  lightGrey: '#F8F9FA', // Background colour
  darkTeal: '#04656B',
  lightTeal: '#84D4D8',
  axisGrey: '#949494',
  invalidGrey: '#BFBBC3',
  selectGrey: '#EEECF1'
};

/**  The values of this enum `CardFormat` are being used to determine the integration type in few of the project's files. */
export enum CardFormat {
  W26 = 'W26', // Wavelynx Card Format
  AVL = 'AVL' // Assa Visionline Card Format
}

/**  The values of `cardFormatLabels` are being used as label names for the Card Formats in dropdown. */
export const cardFormatLabels: Record<CardFormat, string> = {
  [CardFormat.W26]: 'B-Line', // Wavelynx Card Format label
  [CardFormat.AVL]: 'Assa Visionline' // Assa Visionline Card Format label
};

/* This is the default UTC value of 'time.Time' that Go uses as it's default value. */
export const defaultDateTimeUTCValue = '0001-01-01T00:00:00Z';

/* This is the default value of 'uuid.UUID' that Go uses as it's default value. */
export const defaultUUIDValue = '00000000-0000-0000-0000-000000000000';

/**  The values of this `assaCardTypes` are being used as options to determine the type of card for `AVL` integration. */
export const assaCardTypes = [
  { value: 'guest', label: 'Guest' },
  { value: 'staff', label: 'Staff' }
];

// `Assa Visionline (AVL)` integration card type for Guest Cards
export const AssaGuestCardTypeValue = 'guest';

/**  The values of this `assaGuestCardTypes` are being used as options to determine the type of 'guest' assa card for `AVL` integration. Please don't change the order of
 * these card types as they are being used directly in some files to preload the options.  */
export const assaGuestCardTypes = [
  { value: 'Override', label: 'Override' },
  { value: 'Joiner', label: 'Joiner' }
];
